export function getPublishedDay(publishedDate: Date): string {
  const months = [
    'Jan',
    'Feb',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ]
  const wasPublishedThisYear = publishedDate.getFullYear() === new Date().getFullYear()
  const year = wasPublishedThisYear ? '' : publishedDate.getFullYear()
  return `${months[publishedDate.getMonth()]} ${publishedDate.getDate()} ${year}`
}
